const API_PREFIX = '/api/'

/**
 * Turn a path built at runtime (a component's `url` prop, a path from a
 * payload) into the `/api/…` path the HTTP clients expect now that their
 * baseURL is the bare origin. Prefer the Wayfinder helpers whenever the route
 * is known statically.
 *
 * @param {string} path — `undefined`/`null` give `/api/undefined`, as the old
 *   `/api/` baseURL did, rather than throwing
 * @returns {string}
 */
export function apiPath(path) {
  const pathText = String(path)

  if (/^(https?:)?\/\//.test(pathText) || pathText.startsWith(API_PREFIX)) {
    return pathText
  }

  return `${API_PREFIX}${pathText.replace(/^\/+/, '')}`
}
